import React from 'react';
import { cn } from '@/lib/utils';

interface SectionLabelProps {
  children: React.ReactNode;
  showBorder?: boolean;
  className?: string;
}

/**
 * SectionLabel - Uppercase section headers matching design system.
 * Canonical location: blocks/SectionLabel. Re-exported from ui/SectionLabel for backward compatibility.
 */
export const SectionLabel: React.FC<SectionLabelProps> = ({
  children,
  showBorder = false,
  className,
}) => {
  return (
    <div className={cn(showBorder && 'pt-8 border-t border-border', className)}>
      <p className="text-xs text-muted-foreground uppercase tracking-wider mb-4">
        {children}
      </p>
    </div>
  );
};
